import { isEmpty } from 'lodash'

export const CHECKOUT_BASE_URL = 'https://my.trybe.fit'

// Where coaches share links, with the tags each one gets. The product share menu and the
// Reports link builder both read this list, so the same place always gets the same tags
// and reports group those buyers together.
//
// The Instagram bio tags match the ones Instagram adds to bio link clicks on its own, so a
// click that ends up with both sets still reports as one source.
export const LINK_PLACEMENTS = [
  // Instagram adds utm_content=link_in_bio to bio clicks on its own, so leaving content off
  // here keeps bio sales apart from story and DM sales without a second link.
  { id: 'instagram', label: 'Instagram', where: 'Bio link', utm_source: 'ig', utm_medium: 'social' },
  { id: 'youtube', label: 'YouTube', where: 'Channel links', utm_source: 'youtube', utm_medium: 'social' },
  { id: 'tiktok', label: 'TikTok', where: 'Bio link', utm_source: 'tiktok', utm_medium: 'social', utm_content: 'bio' },
  { id: 'facebook', label: 'Facebook', where: 'Page and profile links', utm_source: 'facebook', utm_medium: 'social' },
  { id: 'email', label: 'Email', where: 'Email signature', utm_source: 'email', utm_medium: 'email' },
]

// A page's path after my.trybe.fit/{coachSlug}. The storefront sends a page with
// no published sales page on to another page with a server redirect, which drops
// the tags, so those links go straight to the checkout instead.
export function getStorefrontPagePath({ basePath = '', salesPage }) {
  return isEmpty(salesPage) ? `${basePath}/checkout` : basePath
}

export function getOneTimeProductPagePath({ slug, salesPage }) {
  return getStorefrontPagePath({ basePath: `/product/${slug || 'your-slug'}`, salesPage })
}

const LINK_TAG_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content']

// The server lowercases and trims every tag, so the link shows what will be stored.
export function buildTaggedLink(coachSlug, tags = {}, pagePath = '') {
  const params = new URLSearchParams()
  LINK_TAG_KEYS.forEach((key) => {
    const value = String(tags[key] ?? '')
      .trim()
      .toLowerCase()
    if (value) params.set(key, value)
  })
  const query = params.toString()
  return `${CHECKOUT_BASE_URL}/${coachSlug}${pagePath}${query ? `?${query}` : ''}`
}

// The share menu's links. They are never saved, so they carry no campaign.
export function buildShareLinks({ coachSlug, pagePath = '' }) {
  const plainUrl = buildTaggedLink(coachSlug, {}, pagePath)
  return [
    { id: 'plain', label: 'Plain link', url: plainUrl },
    ...LINK_PLACEMENTS.map(({ id, label, utm_source, utm_medium, utm_content }) => ({
      id,
      label,
      url: buildTaggedLink(coachSlug, { utm_source, utm_medium, utm_content }, pagePath),
    })),
  ]
}
